import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function IdCardSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.idCard')}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      className={clsx(styles.brand, className)}
    >
      <path
        d="M19.6016 33.3319C20.9774 33.3319 22.3422 33.4932 23.693 33.814C24.7267 34.0595 25.7515 34.3992 26.7664 34.8304L27.2008 35.021L27.2047 35.0226L27.6914 35.2491L27.7102 35.2577L27.7203 35.264C28.4033 35.607 28.9573 36.101 29.3695 36.7382C29.7882 37.3853 30.0022 38.1003 30.0023 38.8655V42.3991H26.5813V38.8655C26.5811 38.7649 26.5543 38.6721 26.4852 38.5718C26.4091 38.4619 26.3002 38.3613 26.1414 38.2749C25.2186 37.8281 24.2824 37.4764 23.3328 37.2194L22.9164 37.1124C21.8202 36.8488 20.7154 36.7179 19.6016 36.7179C18.4876 36.7179 17.3833 36.8496 16.2875 37.1132C15.1937 37.3765 14.1169 37.7619 13.0594 38.2741C12.9025 38.3598 12.7951 38.4612 12.7188 38.5718C12.6668 38.6471 12.639 38.7182 12.6281 38.7913L12.6227 38.8655V42.3991H9.20156V38.8655C9.20175 38.1001 9.4161 37.385 9.83438 36.7382C10.1978 36.1766 10.6708 35.7253 11.2461 35.3913L11.4992 35.2554L11.5031 35.2538L11.507 35.2515C12.8248 34.6149 14.16 34.1347 15.5102 33.814C16.8607 33.4932 18.2255 33.332 19.6016 33.3319Z"
        fill="inherit"
      />
      <path d="M45.7062 41.5999H34.4016V37.8663H45.7062V41.5999Z" fill="inherit" />
      <path d="M54.4023 33.8663H34.4016V30.1335H54.4023V33.8663Z" fill="inherit" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6016 21.5999C21.0374 21.5999 22.286 22.1131 23.307 23.1194C24.3285 24.1261 24.8521 25.3606 24.8523 26.7819C24.8523 28.2033 24.3294 29.4382 23.3078 30.4452C22.2865 31.4518 21.0376 31.964 19.6016 31.964C18.2568 31.9639 17.0733 31.5149 16.0875 30.6272L16.0805 30.6202L15.9008 30.4507L15.8945 30.4452C14.8735 29.4382 14.3516 28.2028 14.3516 26.7819C14.3518 25.3609 14.8741 24.1262 15.8953 23.1194C16.9166 22.113 18.1657 21.6 19.6016 21.5999ZM19.6016 24.9843C19.1549 24.9843 18.7786 25.1159 18.4469 25.3897L18.307 25.5163C17.9427 25.8757 17.772 26.2848 17.7719 26.7819C17.7719 27.2794 17.9426 27.6889 18.307 28.0483L18.4469 28.1741C18.7785 28.4478 19.1545 28.5788 19.6016 28.5788C20.1125 28.5788 20.5311 28.408 20.8961 28.0483L21.0242 27.9108C21.301 27.585 21.432 27.2171 21.432 26.7819C21.4319 26.2848 21.2605 25.8758 20.8961 25.5163C20.5309 25.1567 20.112 24.9843 19.6016 24.9843Z"
        fill="inherit"
      />
      <path d="M54.4023 26.1335H34.4016V22.3999H54.4023V26.1335Z" fill="inherit" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4016 53.5999H1.60156V10.3999H62.4016V53.5999ZM5.60156 49.5999H58.4016V14.3999H5.60156V49.5999Z"
        fill="inherit"
      />
    </svg>
  );
}
